export * from './tab-body.component';
export * from './tab-content.directive';
export * from './tab-label.directive';
export * from './tab-link.directive';
export * from './tab-nav-bar.component';
export * from './tab.component';
export * from './tabs.animations';
export * from './tabs.component';
export * from './tabs.module';
